"use client";
import RegisterForm from "@/app/components/common/forms/RegisterForm";
import Link from "next/link";

const RegisterPage = () => {
  return (
    <div className="flex items-center justify-center py-8">
      <div className="max-w-md w-[90%] mx-auto">
        <div className="text-center space-y-2 mb-8">
          <h1 className="text-2xl font-semibold text-gray-900">
            Hesap Oluşturun
          </h1>
          <p className="text-gray-600">
            Yeni hesabınızı oluşturun ve avantajlardan yararlanın
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          <RegisterForm />
        </div>
        <p className="text-gray-600 text-sm mt-6 text-center">
          Zaten hesabınız var mı?{" "}
          <Link
            href="/auth/login"
            className="text-black hover:underline font-medium"
          >
            Giriş yapın
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
